import { render, staticRenderFns } from "./BsButton.vue?vue&type=template&id=77573d06&"
import script from "./BsButton.vue?vue&type=script&lang=js&"
export * from "./BsButton.vue?vue&type=script&lang=js&"
import style0 from "./BsButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports